import type { ReactNode } from 'react';

export function Card({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <section className="rounded-lg border border-chalk-200 bg-white/70 p-5 shadow-sm">
      <h2 className="mb-3 text-lg font-semibold tracking-tight">{title}</h2>
      <div className="space-y-3 text-charcoal-700">{children}</div>
    </section>
  );
}

export function Placeholder({ what, owner }: { what: string; owner: string }) {
  return (
    <Card title={what}>
      <p className="text-sm">
        Scaffold only. Implementation is owned by <strong>{owner}</strong> — see the Callout kanban
        cards.
      </p>
    </Card>
  );
}
